import styled from 'styled-components';
import { Timeline } from '../../../Timeline';
import { Header as MainHeader } from '../../components';
import { PermanentContainer } from '../../../PermanentContainer';
const TOGGLING_MARGIN = 75;
export const AdvertisementPermanentContainer = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: ${(props) => (props.isHidden ? 0 : TOGGLING_MARGIN)}px;
    transition: margin-bottom ease-in-out 400ms;
`;
export const AdvertisementTimeline = styled(Timeline) `
    .Timeline-Progress {
        background: #ffdb1c;
    }
`;
export const AdvertisementPermanent = styled(PermanentContainer) `
    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 0.4) 100%);
        opacity: ${(props) => (props.isHidden ? 1 : 0)};
        transition: opacity 400ms ease-in-out;
    }
`;
export const Header = styled(MainHeader) `
    justify-content: flex-end;
`;
//# sourceMappingURL=index.js.map